import { useTranslation } from '@pasteltech/react-i18n'
import { FontWeight } from '@pasteltech/theme-provider'
import { Link } from 'gatsby'
import { memo } from 'react'
import styled from 'styled-components'
import { CUSTOMER_FEEDBACK_SECTION_FRAGMENT, PagePaths } from '../../constants'
import { LogoIcon } from '../../svg-components'
import { ScreenQuery } from '../../utilities'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: ${({ theme }) => theme.sizes.spacings.xxxxl}px 0;
  gap: ${({ theme }) => theme.sizes.spacings.xxxxl}px;
  background-color: ${({ theme }) => theme.colors.container.highest};
`
const NavigationList = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.sizes.spacings.lg}px;
  ${ScreenQuery.mobile} {
    flex-direction: column;
  }
`
const StyledLink = styled(Link)`
  text-decoration: none;
  color: ${({ theme }) => theme.colors.primary.mainContrast};
  font-size: ${({ theme }) => theme.sizes.fontSize.button}px;
  font-weight: ${FontWeight.bold};
  &:hover {
    cursor: pointer;
    opacity: 0.8;
  }
  &:active {
    opacity: 0.6;
  }
`
const Line = styled.div`
  width: 95%;
  height: 1px;
  background-color: ${({ theme }) => theme.colors.primary.mainContrast};
`
const Copyright = styled.div`
  font-size: ${({ theme }) => theme.sizes.fontSize.label}px;
  font-weight: ${FontWeight.bold};
  color: ${({ theme }) => theme.colors.primary.mainContrast};
  text-align: center;
`
export const Footer = memo(() => {
  const { t } = useTranslation()
  const links = [
    {
      label: t('footer.homePage'),
      path: PagePaths.home,
    },
    {
      label: t('footer.aboutUs'),
      path: PagePaths.aboutUs,
    },
    {
      label: t('footer.services'),
      path: PagePaths.services,
    },
    {
      label: t('footer.customerFeedback'),
      path: `${PagePaths.home}#${CUSTOMER_FEEDBACK_SECTION_FRAGMENT}`,
    },
    {
      label: t('footer.showcase'),
      path: PagePaths.showcase,
    },
    {
      label: t('footer.contactUs'),
      path: PagePaths.contactUs,
    },
  ]
  return (
    <Container>
      <div>
        <LogoIcon />
      </div>
      <NavigationList>
        {links.map((link) => (
          <StyledLink key={`${link.path}-${link.label}`} to={link.path}>
            {link.label}
          </StyledLink>
        ))}
      </NavigationList>
      <Line />
      <Copyright>{t('footer.copyright')}</Copyright>
    </Container>
  )
})

Footer.displayName = 'Footer'
